export const ResourcesSharedNames = {
  shootSmoke: 'atlases_smoke_character',
  crazyWormIdleLong: 'atlases_PGO_Worm_character',
};

export const resourcesShared = [
  {
    name: ResourcesSharedNames.shootSmoke,
    path: 'atlases/shootSmoke/smoke.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/shootSmoke/smoke.atlas',
      },
    },
  },
  {
    name: ResourcesSharedNames.crazyWormIdleLong,
    path: 'atlases/crazyWorm/PGO_Worm.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/crazyWorm/PGO_Worm.atlas',
      },
    },
  },
];
